import ProjectsData from './ProjectsData';
import PageHeader from "../../components/PageHeader";


const ProjectsList = props => {

  return (
    <div>
       <PageHeader title="PROJECTS" description="A curated collection showcasing the seamless fusion of my clients' products with the advanced technology I use to capture them." />
        <div className="container-full-width">
              <div className="projects-items-wrapper">
                  <ProjectsData />

              </div>
        
                       
        </div>
    </div>
  );
};

export default ProjectsList;
